import React, { PropsWithChildren } from 'react';
import { Text } from '@tonic-ui/react';
import ExternalLink from '../../external-link/external-link';

interface ReadmoreLinkProps {
  href: string;
}

const ReadmoreLink = ({ href, children }: PropsWithChildren<ReadmoreLinkProps>) => (
  <ExternalLink
    href={href}
    showIcon={false}
    fontFamily="opensans"
    color="#4d4d4f !important"
    textDecoration="none"
    _hover={{ textDecoration: 'underline' }}
    _focus={{ outlineColor: '#4D4D4F' }}
  >
    <Text fontSize="18px" lineHeight="23px">
      {children}
    </Text>
  </ExternalLink>
);

export default ReadmoreLink;
